(ns ui.view.entity-graph.sub
  (:require [re-frame.core :as rf]
            [reagent.ratom :as ratom]
            [common.util :as cu]
            [common.entity :as entity]
            [common.localization :as loc]
            [common.schema.entities.graph-reference :as graph-reference]
            [clojure.set :as set]
            [clojure.string :as string]
            [ui.state.session.sub :as session-sub]
            [ui.view.entity-graph.utils :as utils]
            [ui.view.entity-graph.model :as m]
            [frontend.state.permissions :as permissions]
            [frontend.state.current-session :as session]))

(rf/reg-sub-raw
 m/graph-entities
 (fn [_]
   (ratom/reaction
    (let [companies @(rf/subscribe [::session-sub/entities-for-type
                                    :entity.type/graph-company])
          persons @(rf/subscribe [::session-sub/entities-for-type
                                  :entity.type/graph-person])
          fof-assets @(rf/subscribe [::session-sub/entities-for-type
                                     :entity.type/graph-fof-asset])
          funds @(rf/subscribe [::session-sub/entities-for-type
                                :entity.type/graph-fund])]
      (-> (vec companies)
          (into persons)
          (into fof-assets)
          (into funds))))))

(rf/reg-sub-raw
 m/map-profiles
 (fn [_]
   (ratom/reaction
    @(rf/subscribe [m/graph-entities]))))

(rf/reg-sub-raw
 m/graph-references
 (fn [_]
   (ratom/reaction
    @(rf/subscribe [::session-sub/entities-for-type
                    :entity.type/graph-reference]))))

(rf/reg-sub-raw
 m/connectors
 (fn [_]
   (ratom/reaction
    (->> @(rf/subscribe [m/graph-references])
         (filterv (fn [{:keys [graph-reference/type]}]
                    (contains? graph-reference/connector-types type)))))))

(rf/reg-sub-raw
 m/all-view-configs
 (fn [_]
   (ratom/reaction
    @(rf/subscribe [::session-sub/entities-for-type
                    :entity.type/graph-config]))))

(comment

  ;;@(rf/subscribe [::session-sub/entity 5555555555555556])
  #_(-> (get-in @re-frame.db/app-db ui.state.session.model/entities-path))

  (let [ctx {:main-entity-id 17592186064179}
        p @(rf/subscribe [m/provider ctx])
        get-t (-> p
                  (:get-handle-connections))]
    (get-t "target" "17592186067202" #_"top-target-handle")
    #_((:get-internal-node p) "17592186067202")
    #_((:get-nodes p)))

  :rcf)

(rf/reg-sub
 m/connection-tuples
 (fn [[_ ctx]]
   {:connectors (rf/subscribe [m/connectors ctx])})
 (fn [args _]
   (utils/connection-tuples args)))

(rf/reg-sub
 m/connection-tuples-by-node-id
 (fn [[_ ctx]]
   {:connection-tuples (rf/subscribe [m/connection-tuples ctx])})
 (fn [args _]
   (utils/connection-tuples-by-id args)))

(rf/reg-sub
 ;; Don't use directly - identity via ctx (i.e. main-entity-id) needed
 m/root-state
 (fn [db _]
   (get db m/root)))

(rf/reg-sub
 ;; State, specific to a single instance of entity-graph (i.e. specific to main entity)
 m/state
 (fn [[_ _args]]
   {:root-state (rf/subscribe [m/root-state])})
 (fn [{:keys [root-state]}
      [_ {:keys [main-entity-id]}]]
   (get root-state main-entity-id)))

(rf/reg-sub
 m/creating
 (fn [[_ ctx]]
   (rf/subscribe [m/state ctx]))
 (fn [state _]
   (get state m/creating-key)))

(rf/reg-sub
 m/provider
 (fn [[_ ctx]]
   (rf/subscribe [m/state ctx]))
 (fn [state _]
   (get state m/provider-key)))

(rf/reg-sub
 m/show-all-gref-sections
 (fn [[_ ctx]]
   (rf/subscribe [m/state ctx]))
 (fn [state [_ {:keys [section]}]]
   (get-in state [m/show-all-gref-sections-key section])))

(rf/reg-sub
 m/ready?
 (fn [[_ ctx]]
   (rf/subscribe [m/state ctx]))
 (fn [state _]
   (get state m/ready-key)))

(rf/reg-sub
 m/loaded?
 (fn [[_ ctx]]
   (rf/subscribe [m/state ctx]))
 (fn [state _]
   (get state m/loaded-key)))

(rf/reg-sub
 m/ephemeral
 (fn [[_ ctx]]
   (rf/subscribe [m/state ctx]))
 (fn [state _]
   (get state m/ephemeral-key)))

(rf/reg-sub
 m/ephemeral-positions
 (fn [[_ ctx]]
   (rf/subscribe [m/ephemeral ctx]))
 (fn [ephemeral-state _]
   (get ephemeral-state m/ephemeral-positions-key)))

(rf/reg-sub
 m/ephemeral-hide-rules
 (fn [[_ ctx]]
   (rf/subscribe [m/ephemeral ctx]))
 (fn [ephemeral-state _]
   (get ephemeral-state m/ephemeral-hide-rules-key)))

(rf/reg-sub
 m/main-map-profile
 (fn [[_ ctx]]
   (rf/subscribe [m/map-profiles ctx]))
 (fn [map-profiles [_ {:keys [main-entity-id]}]]
   (->> map-profiles
        (cu/filter-by :graph-entity/entity main-entity-id)
        first)))

(rf/reg-sub
 m/main-map-profile-id
 (fn [[_ ctx]]
   (rf/subscribe [m/main-map-profile ctx]))
 (fn [map-profile _]
   (:db/id map-profile)))

(rf/reg-sub
 m/entity-map-profile
 (fn [[_ ctx]]
   (rf/subscribe [m/map-profiles ctx]))
 (fn [map-profiles [_ {:keys [entity-id]}]]
   (->> map-profiles
        (cu/filter-by :graph-entity/entity entity-id)
        first)))

(rf/reg-sub
 m/view-configs
 (fn [[_ ctx]]
   {:all-view-configs (rf/subscribe [m/all-view-configs ctx])
    :main-map-profile-id (rf/subscribe [m/main-map-profile-id ctx])})
 (fn [{:keys [all-view-configs main-map-profile-id]} _]
   (->> all-view-configs
        (filterv (fn [{:graph-config/keys [entity]}]
                   (= entity main-map-profile-id))))))

(rf/reg-sub
 m/view-config
 (fn [[_ ctx]]
   (rf/subscribe [m/state ctx]))
 (fn [state _]
   (get state m/view-config-key)))

(rf/reg-sub
 m/selected-system-config
 (fn [[_ ctx]]
   (rf/subscribe [m/state ctx]))
 (fn [state _]
   (get state m/selected-system-config-key)))

(rf/reg-sub
 m/manual-positions?
 (fn [[_ ctx]]
   (rf/subscribe [m/view-config ctx]))
 (fn [view-config-state _]
   (get view-config-state m/manual-positions-key)))

(rf/reg-sub
 m/sidebar-pinned?
 (fn [[_ ctx]]
   (rf/subscribe [m/view-config ctx]))
 (fn [view-config-state _]
   (get view-config-state m/sidebar-pinned-key)))

(rf/reg-sub
 m/sidebar-collapsed?
 (fn [[_ ctx]]
   {:sidebar-pinned? (rf/subscribe [m/sidebar-pinned? ctx])
    :sidebar-mode (rf/subscribe [m/sidebar-mode ctx])})
 (fn [{:keys [sidebar-pinned? sidebar-mode]} _]
   (and (not sidebar-pinned?)
        (not= sidebar-mode :expanded))))

(rf/reg-sub
 m/sidebar-mode
 (fn [[_ ctx]]
   (rf/subscribe [m/ephemeral ctx]))
 (fn [ephemeral-state _]
   (get ephemeral-state m/sidebar-mode-key)))

(rf/reg-sub
 m/view-positions
 (fn [[_ ctx]]
   (rf/subscribe [m/view-config ctx]))
 (fn [view-config-state _]
   (get view-config-state m/view-positions-key)))

(defn hide-rules
  [{:keys [view-config selected-system-config]} _]
  (let [hide-rules (get view-config m/hide-rules-key)]
    (if selected-system-config
      {:system-config selected-system-config}
      hide-rules)))

(rf/reg-sub
 m/hide-rules
 (fn [[_ ctx]]
   {:view-config (rf/subscribe [m/view-config ctx])
    :selected-system-config (rf/subscribe [m/selected-system-config ctx])})
 hide-rules)

(rf/reg-sub
 m/defaults
 (fn [[_ ctx]]
   (rf/subscribe [m/view-config ctx]))
 (fn [view-config-state _]
   (get view-config-state m/defaults-key)))

(rf/reg-sub
 m/default-path-type
 (fn [[_ ctx]]
   (rf/subscribe [m/defaults ctx]))
 (fn [defaults _]
   (get defaults m/path-type-key :smooth-step)))

(defn has-pep-attribute?
  [_ _]
  (let [attribute :graph-entity/pep?
        entity-type :entity.type/graph-person
        read-access? (permissions/field-read-access?
                      attribute entity-type nil)]
    read-access?))

(rf/reg-sub
 m/has-pep-attribute?
 has-pep-attribute?)

(rf/reg-sub
 m/highlight-pep?
 (fn [[_ ctx]]
   {:defaults (rf/subscribe [m/defaults ctx])
    :has-pep-attribute? (rf/subscribe [m/has-pep-attribute? ctx])})
 (fn [{:keys [defaults has-pep-attribute?]} _]
   (and has-pep-attribute?
        (cu/default-boolean
         true
         (get defaults m/highlight-pep-key)))))

(defn show-icons?
  [{:keys [defaults]} _]
  (cu/default-boolean
   true
   (get defaults m/show-icons-key)))

(rf/reg-sub
 m/show-icons?
 (fn [[_ ctx]]
   {:defaults (rf/subscribe [m/defaults ctx])})
 show-icons?)

(defn default-value
  [defaults [_ {:keys [path default]}]]
  (cu/default-boolean
   default
   (get-in defaults path default)))

(rf/reg-sub
 m/default-value
 (fn [[_ ctx]]
   (rf/subscribe [m/defaults ctx]))
 default-value)

(defn background-variant
  [defaults _]
  (if (cu/default-boolean
       true
       (get defaults m/hide-grid-key))
    ""
    "dots"))

(rf/reg-sub
 m/background-variant
 (fn [[_ ctx]]
   (rf/subscribe [m/defaults ctx]))
 background-variant)

(rf/reg-sub
 m/default-connector-path-type
 (fn [[_ ctx]]
   {:defaults (rf/subscribe [m/defaults ctx])
    #_#_:default-path-type (rf/subscribe [m/default-path-type ctx])})
 (fn [{:keys [defaults #_default-path-type]} [_ {:keys [connector-type] :as _ctx}]]
   ;; nil indicates using global-default
   (get-in defaults [connector-type m/path-type-key] #_default-path-type)))

(rf/reg-sub
 m/connector-path-type
 (fn [[_ ctx]]
   {:view-config (rf/subscribe [m/view-config ctx])
    :default-path-type (rf/subscribe [m/default-path-type ctx])
    :default-connector-path-type (rf/subscribe [m/default-connector-path-type ctx])})
 (fn [{:keys [view-config
              default-connector-path-type
              default-path-type]} [_ {:keys [connector-id raw?] :as _ctx}]]
   ;; raw? => skip default values and return nil if not found
   (if raw?
     (get-in view-config [:connectors connector-id m/path-type-key])
     (or (get-in view-config [:connectors connector-id m/path-type-key])
         default-connector-path-type
         default-path-type))))

(rf/reg-sub
 m/connector-line-type
 (fn [[_ ctx]]
   {:view-config (rf/subscribe [m/view-config ctx])
    :default-connector-line-type (rf/subscribe [m/default-connector-line-type ctx])})
 (fn [{:keys [view-config
              default-connector-line-type]} [_ {:keys [connector-id] :as _ctx}]]
   (or (get-in view-config [:connectors connector-id m/line-type-key])
       default-connector-line-type
       :solid)))

(rf/reg-sub
 m/visible-nodes-edges-ids
 (fn [[_ ctx]]
   {:connection-tuples-by-node-id (rf/subscribe [m/connection-tuples-by-node-id])
    :hide-rules (rf/subscribe [m/hide-rules ctx])
    :main-map-profile-id (rf/subscribe [m/main-map-profile-id ctx])})
 (fn [{:keys [connection-tuples-by-node-id
              hide-rules
              main-map-profile-id] :as _args} _]
   (if main-map-profile-id
     (let [visible (utils/mark-as-visible
                    {:visited #{}
                     :visible-nodes #{main-map-profile-id}
                     :visible-edges #{}
                     :hide-rules hide-rules
                     :connection-tuples-by-node-id connection-tuples-by-node-id
                     :to-visit [main-map-profile-id]})]
       visible)
     {:nodes #{}
      :edges #{}})))

(rf/reg-sub
 m/reachable-nodes-edges-ids
 (fn [[_ ctx]]
   {:connection-tuples-by-node-id (rf/subscribe [m/connection-tuples-by-node-id])
    :main-map-profile-id (rf/subscribe [m/main-map-profile-id ctx])})
 (fn [{:keys [connection-tuples-by-node-id
              main-map-profile-id] :as _args} _]
   (if main-map-profile-id
     (let [visible (utils/mark-as-visible
                    {:visited #{}
                     :visible-nodes #{main-map-profile-id}
                     :visible-edges #{}
                     :hide-rules nil
                     :connection-tuples-by-node-id connection-tuples-by-node-id
                     :to-visit [main-map-profile-id]})]
       visible)
     {:nodes #{}
      :edges #{}})))

(rf/reg-sub
 m/reachable-edge-ids-set
 (fn [[_ ctx]]
   {:reachable-nodes-edges-ids (rf/subscribe
                                [m/reachable-nodes-edges-ids ctx])})
 (fn [{:keys [reachable-nodes-edges-ids]} _]
   (let [edges (:edges reachable-nodes-edges-ids)]
     edges)))

(rf/reg-sub
 m/reachable-connectors
 (fn [[_ ctx]]
   {:connectors (rf/subscribe [m/connectors ctx])
    :reachable-edge-ids-set (rf/subscribe
                             [m/reachable-edge-ids-set ctx])})
 (fn [{:keys [reachable-edge-ids-set connectors]} _]
   (->> connectors
        (filterv (fn [{:keys [db/id]}]
                   (contains? reachable-edge-ids-set id))))))

(rf/reg-sub
 m/reachable-connectors-of-type
 (fn [[_ ctx]]
   {:reachable-connectors (rf/subscribe [m/reachable-connectors ctx])})
 (fn [{:keys [reachable-connectors]} [_ {:keys [connector-type]}]]
   (->> reachable-connectors
        (filterv (fn [{:keys [graph-reference/type]}]
                   (= type connector-type))))))

(rf/reg-sub
 m/visible-node-ids-set
 (fn [[_ ctx]]
   {:visible-nodes-edges-ids (rf/subscribe
                              [m/visible-nodes-edges-ids ctx])})
 (fn [{:keys [visible-nodes-edges-ids]} _]
   (let [nodes (:nodes visible-nodes-edges-ids)]
     nodes)))

(rf/reg-sub
 m/visible-map-profile-ids-set
 (fn [[_ ctx]]
   {:visible-map-profiles (rf/subscribe [m/visible-map-profiles ctx])})
 (fn [{:keys [visible-map-profiles]} [_ _ctx]]
   (->> visible-map-profiles
        (into #{}
              (map :db/id)))))

(rf/reg-sub
 m/ordered-visible-map-profile-ids
 (fn [[_ ctx]]
   {:visible-map-profiles (rf/subscribe [m/visible-map-profiles ctx])})
 (fn [{:keys [visible-map-profiles]} _]
   (->> visible-map-profiles
        (mapv :db/id))))

(defn resolve-known-positions
  [{:keys [view-positions ordered-visible-map-profile-ids]}]
  (->> ordered-visible-map-profile-ids
       (reduce (fn [m id]
                 (let [position (get view-positions id)]
                   (if position
                     (assoc! m id position)
                     m)))
               (transient {}))
       persistent!))

(rf/reg-sub
 m/known-positions
 (fn [[_ ctx]]
   {:view-positions (rf/subscribe [m/view-positions ctx])
    :ordered-visible-map-profile-ids (rf/subscribe
                                      [m/ordered-visible-map-profile-ids ctx])})
 (fn [args _]
   (resolve-known-positions args)))

(defn resolve-unknown-position-nodes
  [{:keys [known-positions ordered-visible-map-profile-ids]}]
  (->> ordered-visible-map-profile-ids
       (filterv (fn [id]
                  (not (contains? known-positions id))))))

(rf/reg-sub
 m/unknown-position-nodes
 (fn [[_ ctx]]
   {:known-positions (rf/subscribe [m/known-positions ctx])
    :ordered-visible-map-profile-ids (rf/subscribe
                                      [m/ordered-visible-map-profile-ids ctx])})
 (fn [args _]
   (resolve-unknown-position-nodes args)))

(defn resolve-top-right
  [{:keys [known-positions]}]
  (if-let [positions (->> known-positions
                          vals
                          seq)]
    [(->> positions
          (mapv :x)
          (apply max))
     (->> positions
          (mapv :y)
          (apply min))]
    [(- 0.0 m/WIDTH m/PADDING) 0.0]))

(comment

  (if-let [p (->> @(rf/subscribe [m/known-positions {:main-entity-id 17592186050455}])
                  vals
                  seq)]
    :a
    :b)

  (resolve-top-right {:known-positions
                      @(rf/subscribe [m/known-positions {:main-entity-id 17592186050455}])})

  :f)

(rf/reg-sub
 m/top-right
 (fn [[_ ctx]]
   {:known-positions (rf/subscribe [m/known-positions ctx])})
 (fn [args _]
   (resolve-top-right args)))

(defn resolve-unknown-positions
  [{:keys [top-right unknown-position-nodes]}]
  (let [[x y] top-right
        start-x (+ x m/WIDTH m/PADDING)
        start-y (- y m/HEIGHT m/PADDING)]
    (->> unknown-position-nodes
         (reduce (fn [{{:keys [x y]} :prev :as m} node-id]
                   (let [new-y (+ y m/HEIGHT m/PADDING)
                         new-pos {:x x :y new-y}]
                     (-> m
                         (assoc-in [:acc node-id] new-pos)
                         (assoc :prev new-pos))))
                 {:acc {} :prev {:x start-x :y start-y}})
         :acc)))

(rf/reg-sub
 m/resolved-positions
 (fn [[_ ctx]]
   {:top-right (rf/subscribe [m/top-right ctx])
    :unknown-position-nodes (rf/subscribe [m/unknown-position-nodes ctx])})
 (fn [args _]
   (resolve-unknown-positions args)))

(rf/reg-sub
 m/positions
 (fn [[_ ctx]]
   {:ephemeral-positions (rf/subscribe [m/ephemeral-positions ctx])
    :known-positions (rf/subscribe [m/known-positions ctx])
    :resolved-positions (rf/subscribe [m/resolved-positions ctx])})
 (fn [{:keys [ephemeral-positions
              known-positions
              resolved-positions]} _]
   (merge resolved-positions known-positions ephemeral-positions)))

(rf/reg-sub
 m/selected-nodes
 (fn [[_sub-id ctx]]
   {:ephemeral-state (rf/subscribe [m/ephemeral ctx])})
 (fn [{:keys [ephemeral-state]} _]
   (get ephemeral-state m/selected-nodes-key)))

(rf/reg-sub
 m/selected-visible-nodes
 (fn [[_sub-id ctx]]
   {:selected-nodes (rf/subscribe [m/selected-nodes ctx])
    :visible-nodes (rf/subscribe [m/visible-map-profile-ids-set ctx])})
 (fn [{:keys [selected-nodes visible-nodes]} _]
   (set/intersection selected-nodes visible-nodes)))

#_(rf/reg-sub
 m/one-selected-node
 (fn [[_sub-id ctx]]
   {:selected-visible-nodes (rf/subscribe [m/selected-visible-nodes ctx])})
 (fn [{:keys [selected-visible-nodes]} _]
   (when (cu/one-element? selected-visible-nodes)
     (first selected-visible-nodes))))

;; allow selecting hidden nodes:
;; TODO consider separating selected-node vs. opening node in map-profile-curtain
(rf/reg-sub
 m/one-selected-node
 (fn [[_sub-id ctx]]
   {:selected-nodes (rf/subscribe [m/selected-nodes ctx])})
 (fn [{:keys [selected-nodes]} _]
   (when (cu/one-element? selected-nodes)
     (first selected-nodes))))

(rf/reg-sub
 m/selected-edges
 (fn [[_sub-id ctx]]
   {:ephemeral-state (rf/subscribe [m/ephemeral ctx])})
 (fn [{:keys [ephemeral-state]} _]
   (get ephemeral-state m/selected-edges-key)))

(rf/reg-sub
 m/selected-visible-edges
 (fn [[_sub-id ctx]]
   {:selected-edges (rf/subscribe [m/selected-edges ctx])
    :visible-edges (rf/subscribe [m/visible-edge-ids-set ctx])})
 (fn [{:keys [selected-edges visible-edges]} _]
   (set/intersection selected-edges visible-edges)))

(rf/reg-sub
 m/one-selected-visible-edge
 (fn [[_sub-id ctx]]
   {:selected-visible-edges (rf/subscribe [m/selected-visible-edges ctx])})
 (fn [{:keys [selected-visible-edges]} _]
   (when (cu/one-element? selected-visible-edges)
     (first selected-visible-edges))))

(rf/reg-sub
 m/one-selected-edge
 (fn [[_sub-id ctx]]
   {:selected-edges (rf/subscribe [m/selected-edges ctx])})
 (fn [{:keys [selected-edges]} _]
   (when (cu/one-element? selected-edges)
     (first selected-edges))))

(rf/reg-sub
 m/viewed
 (fn [[_sub-id ctx]]
   {:ephemeral-state (rf/subscribe [m/ephemeral ctx])})
 (fn [{:keys [ephemeral-state]} _]
   (get ephemeral-state m/viewed-key)))

(defn flow-nodes
  [{:keys [selected-nodes visible-map-profiles
           top-right resolved-positions reconnecting-node-id
           positions ctx]}]
  (let [nodes (->> visible-map-profiles
                   (mapv (fn [{:keys [db/id] :as map-profile}]
                           (utils/flow-node
                            {:selected? (contains? selected-nodes id)
                             :reconnecting? (= reconnecting-node-id
                                               id)
                             :no-reconnecting? (nil? reconnecting-node-id)
                             :position (get positions id)
                             :ctx ctx}
                            map-profile))))
        nodes (if (seq resolved-positions)
                (conj nodes
                      {:id "non-positioned-note"
                       :draggable false
                       :selectable false
                       :connectable false
                       :type :annotation-node
                       :style {:border "none"
                               :background-color "transparent"}
                       :handles nil
                       :position (let [[x y] top-right
                                       x (+ x m/PADDING m/WIDTH)
                                       y (- y m/HEIGHT)]
                                   {:x x :y y})
                       :measured {:width 150 :height 50}
                       :data {:label "Non-positioned nodes:"}})
                nodes)]
    nodes))

(rf/reg-sub
 m/flow-nodes
 (fn [[_sub-id ctx]]
   {:selected-nodes (rf/subscribe [m/selected-nodes ctx])
    :positions (rf/subscribe [m/positions ctx])
    :resolved-positions (rf/subscribe [m/resolved-positions ctx])
    :top-right (rf/subscribe [m/top-right ctx])
    :loaded? (rf/subscribe [m/loaded? ctx])
    :reconnecting-node-id (rf/subscribe [m/reconnecting-node-id ctx])
    :visible-map-profiles (rf/subscribe [m/visible-map-profiles ctx])})
 (fn [{:keys [loaded?] :as args} [_ ctx]]
   (if loaded?
     (flow-nodes (assoc args :ctx ctx))
     [])))

(defn resolve-display-visibility
  [{:keys [ephemeral-hide-rules]}]
  (boolean ephemeral-hide-rules))

(rf/reg-sub
 m/display-visibility-changes?
 (fn [[_sub-id ctx]]
   ;;TODO save to state or deduce somehow?
   ;; e.g. if changes to visibility-rules
   ;; (ephemeral-rules not nil and differ from 'current'-rules)
   {:ephemeral-hide-rules (rf/subscribe [m/ephemeral-hide-rules ctx])})
 (fn [args _]
   (resolve-display-visibility args)))

;;TODO: won't work properly with system-configs - fix when needed:
(defn hidden-connector?
  [hide-rules connector]
  ;;first spike also included:
  ;; (:contains (:global hide-rules) (:graph-reference/type connector))
  (contains? (:connectors hide-rules) (:db/id connector)))

(defn resolve-visible-connectors
  [{:keys [display-visibility-changes? visible-map-profile-ids-set
           connectors hide-rules ephemeral-hide-rules]}]
  (->> connectors
       (filterv (fn [connector]
                  (if display-visibility-changes?
                    (or (not (hidden-connector? hide-rules connector))
                        (not (hidden-connector? ephemeral-hide-rules connector)))
                    (not (hidden-connector? hide-rules connector)))))
       (filterv (fn [{:graph-reference/keys [source target]}]
                  ;; both must be visible:
                  (and (contains? visible-map-profile-ids-set source)
                       (contains? visible-map-profile-ids-set target))))))

(rf/reg-sub
 m/visible-connectors
 (fn [[_sub-id ctx]]
   {:display-visibility-changes? (rf/subscribe [m/display-visibility-changes? ctx])
    :hide-rules (rf/subscribe [m/hide-rules ctx])
    :ephemeral-hide-rules (rf/subscribe [m/ephemeral-hide-rules ctx])
    :visible-map-profile-ids-set (rf/subscribe [m/visible-map-profile-ids-set ctx])
    :connectors (rf/subscribe [m/connectors ctx])})
 (fn [args [_ _ctx]]
   (resolve-visible-connectors args)))

(defn resolve-visible-connectors-of-type
  [{:keys [visible-connectors]} {:keys [connector-type]}]
  (->> visible-connectors
       (filterv (fn [{:keys [graph-reference/type]}]
                  (= type connector-type)))))

(rf/reg-sub
 m/visible-connectors-of-type
 (fn [[_sub-id ctx]]
   {:visible-connectors (rf/subscribe [m/visible-connectors ctx])})
 (fn [args [_ ctx]]
   (resolve-visible-connectors-of-type args ctx)))

(rf/reg-sub
 m/default-connector-line-type
 (fn [[_ ctx]]
   {:defaults (rf/subscribe [m/defaults ctx])})
 (fn [{:keys [defaults]} [_ {:keys [connector-type] :as _ctx}]]
   (get-in defaults [m/line-type-key connector-type])))

(rf/reg-sub
 m/connector-type-line-types
 (fn [[_ ctx]]
   {:defaults (rf/subscribe [m/defaults ctx])})
 (fn [{:keys [defaults]} _]
   (get defaults m/line-type-key)))

(rf/reg-sub
 m/default-connector-source-handle
 (fn [[_ ctx]]
   {:defaults (rf/subscribe [m/defaults ctx])})
 (fn [{:keys [defaults]} [_ {:keys [connector-type] :as _ctx}]]
   (get-in defaults [m/source-handle-key connector-type])))

(rf/reg-sub
 m/default-connector-target-handle
 (fn [[_ ctx]]
   {:defaults (rf/subscribe [m/defaults ctx])})
 (fn [{:keys [defaults]} [_ {:keys [connector-type] :as _ctx}]]
   (get-in defaults [m/target-handle-key connector-type])))

(rf/reg-sub
 m/connector-type-source-handles
 (fn [[_ ctx]]
   {:defaults (rf/subscribe [m/defaults ctx])})
 (fn [{:keys [defaults]} _]
   (get defaults m/source-handle-key)))

(rf/reg-sub
 m/connector-type-target-handles
 (fn [[_ ctx]]
   {:defaults (rf/subscribe [m/defaults ctx])})
 (fn [{:keys [defaults]} _]
   (get defaults m/target-handle-key)))

(rf/reg-sub
 m/source-handles
 (fn [[_ ctx]]
   {:view-config (rf/subscribe [m/view-config ctx])})
 (fn [{:keys [view-config]} _]
   (get-in view-config [:connectors m/source-handle-key])))

(rf/reg-sub
 m/target-handles
 (fn [[_ ctx]]
   {:view-config (rf/subscribe [m/view-config ctx])})
 (fn [{:keys [view-config]} _]
   (get-in view-config [:connectors m/target-handle-key])))

(rf/reg-sub
 m/source-handle
 (fn [[_ ctx]]
   {:source-handles (rf/subscribe [m/source-handles ctx])})
 (fn [{:keys [source-handles]} [_ {:keys [connector-id] :as _ctx}]]
   (get source-handles connector-id)))

(rf/reg-sub
 m/target-handle
 (fn [[_ ctx]]
   {:target-handles (rf/subscribe [m/target-handles ctx])})
 (fn [{:keys [target-handles]} [_ {:keys [connector-id] :as _ctx}]]
   (get target-handles connector-id)))

(defn flow-edges
  [{:keys [selected-edges visible-connectors
           one-selected-visible-edge
           connector-type-source-handles connector-type-target-handles
           source-handles target-handles ctx]}]
  (->> visible-connectors
       (mapv (fn [{:keys [db/id graph-reference/type] :as connector}]
               (let [default-source-handle (get connector-type-source-handles type)
                     default-target-handle (get connector-type-target-handles type)]
                 (utils/flow-edge {:selected? (contains? selected-edges id)
                                   :one-selected-visible? (= one-selected-visible-edge
                                                             id)
                                   :source-handle
                                   (get source-handles id
                                        default-source-handle)
                                   :target-handle
                                   (get target-handles id
                                        default-target-handle)
                                   :ctx ctx}
                                  connector))))))

(rf/reg-sub
 m/flow-edges
 (fn [[_sub-id ctx]]
   {:loaded? (rf/subscribe [m/loaded? ctx])
    :selected-edges (rf/subscribe [m/selected-edges ctx])
    :one-selected-visible-edge (rf/subscribe [m/one-selected-visible-edge ctx])
    :visible-connectors (rf/subscribe [m/visible-connectors ctx])
    :source-handles (rf/subscribe [m/source-handles ctx])
    :target-handles (rf/subscribe [m/target-handles ctx])
    :connector-type-source-handles (rf/subscribe [m/connector-type-source-handles ctx])
    :connector-type-target-handles (rf/subscribe [m/connector-type-target-handles ctx])})
 (fn [{:keys [loaded?] :as args} [_ ctx]]
   (if loaded?
     (flow-edges (assoc args :ctx ctx))
     [])))

(defn by-target-handles
  [{:keys [connector-type-target-handles target-handles]} connectors]
  (->> connectors
       (reduce (fn [m {:keys [graph-reference/type db/id]}]
                 (let [default-target-handle (get m/default-target-handle-by-type type)
                       target-handle-by-type (get connector-type-target-handles type
                                                  default-target-handle)
                       target-handle (get target-handles id target-handle-by-type)]
                   (update m target-handle (fnil conj #{}) id)))
               {})))

(defn target-handles-by-id
  [{:keys [visible-connectors] :as args} [_ _ctx]]
  (let [by-node-id (->> visible-connectors
                        (group-by :graph-reference/target)
                        (reduce
                         (fn [m [node-id connectors]]
                           (assoc m node-id (by-target-handles
                                             args connectors)))
                         {}))]
    by-node-id))

(rf/reg-sub
 m/target-handles-by-id
 (fn [[_sub-id ctx]]
   {:visible-connectors (rf/subscribe [m/visible-connectors ctx])
    :connector-type-target-handles (rf/subscribe [m/connector-type-target-handles ctx])
    :target-handles (rf/subscribe [m/target-handles ctx])})
 target-handles-by-id)

(rf/reg-sub-raw
 m/map-profile-ids-set
 (fn [_]
   (ratom/reaction
    (->> @(rf/subscribe [m/map-profiles])
         (into #{}
               (map :db/id))))))

(rf/reg-sub
 m/graph-references-for
 (fn [[_ ctx]]
   {:graph-references (rf/subscribe [m/graph-references ctx])})
 (fn [{:keys [graph-references]} [_ {map-profile-id :map-profile-id :as _ctx}]]
   (->> graph-references
        (filterv (fn [{:graph-reference/keys [source target]}]
                   (or (= source map-profile-id)
                       (= target map-profile-id)))))))

(rf/reg-sub
 m/connectors-for
 (fn [[_ ctx]]
   {:connectors (rf/subscribe [m/connectors ctx])})
 (fn [{:keys [connectors]} [_ {map-profile-id :map-profile-id :as _ctx}]]
   (->> connectors
        (filterv (fn [{:graph-reference/keys [source target]}]
                   (or (= source map-profile-id)
                       (= target map-profile-id)))))))

(rf/reg-sub
 m/graph-references-of-type-for
 (fn [[_ ctx]]
   {:graph-references (rf/subscribe [m/graph-references-for ctx])})
 ;; type: e.g. :graph-reference.type/ownership; direction: :source or :target which defines
 ;;  whether the given map-profile-id is source or target of the connector
 (fn [{:keys [graph-references]} [_ {:keys [map-profile-id
                                            connector-type direction] :as _ctx}]]
   (->> graph-references
        (filterv (fn [{:graph-reference/keys [source target type]}]
                   (and (= type connector-type)
                        (cond (= direction :source)
                              (= source map-profile-id)

                              (= direction :target)
                              (= target map-profile-id)

                              ;; no direction => either is fine:
                              :else
                              true)))))))

;;TODO can likely be removed:
(rf/reg-sub
 m/connectors-of-type-for
 (fn [[_ ctx]]
   {:connectors (rf/subscribe [m/connectors-for ctx])})
 ;; type: e.g. :graph-reference.type/ownership; direction: :source or :target which defines
 ;;  whether the given map-profile-id is source or target of the connector
 (fn [{:keys [connectors]} [_ {:keys [map-profile-id
                                      connector-type direction] :as _ctx}]]
   (->> connectors
        (filterv (fn [{:graph-reference/keys [source target type]}]
                   (and (= type connector-type)
                        (cond (= direction :source)
                              (= source map-profile-id)

                              (= direction :target)
                              (= target map-profile-id)

                              ;; no direction => either is fine:
                              :else
                              true)))))))

(rf/reg-sub
 m/connectors-of-type
 (fn [[_ ctx]]
   {:connectors (rf/subscribe [m/connectors ctx])})
 (fn [{:keys [connectors]} [_ {:keys [connector-type] :as _ctx}]]
   (->> connectors
        (filterv (fn [{:keys [graph-reference/type]}]
                   (= type connector-type))))))

(rf/reg-sub-raw
 m/connector-ids-set
 (fn [_]
   (ratom/reaction
    (->> @(rf/subscribe [m/connectors])
         (into #{}
               (map :db/id))))))

(rf/reg-sub
 m/visible-edge-ids-set
 (fn [[_ ctx]]
   {:visible-nodes-edges-ids (rf/subscribe
                              [m/visible-nodes-edges-ids ctx])})
 (fn [{:keys [visible-nodes-edges-ids]} _]
   (:edges visible-nodes-edges-ids)))

(defn resolve-preview-changes
  [{:keys [visible-nodes-edges-ids main-map-profile-id
           map-profile-ids-set connector-ids-set
           connection-tuples-by-node-id ephemeral-hide-rules
           display-visibility-changes?]}]
  (when display-visibility-changes?
    (let [current-visible-nodes (:nodes visible-nodes-edges-ids)
          current-hidden-nodes (set/difference map-profile-ids-set current-visible-nodes)
          current-visible-edges (:edges visible-nodes-edges-ids)
          new-nodes-edges (utils/mark-as-visible
                           {:visited #{}
                            :visible-nodes #{}
                            :visible-edges #{}
                            :hide-rules ephemeral-hide-rules
                            :connection-tuples-by-node-id connection-tuples-by-node-id
                            :to-visit [main-map-profile-id]})
          new-visible-nodes (:nodes new-nodes-edges)
          new-visible-edges (:edges new-nodes-edges)
          new-hidden-nodes (set/difference map-profile-ids-set new-visible-nodes)
          current-hidden-edges (set/difference connector-ids-set current-visible-edges)
          new-hidden-edges (set/difference connector-ids-set new-visible-edges)]
      {:hide-nodes (set/difference new-hidden-nodes current-hidden-nodes)
       :show-nodes (set/difference new-visible-nodes current-visible-nodes)
       :hide-edges (set/difference new-hidden-edges current-hidden-edges)
       :show-edges (set/difference new-visible-edges current-visible-edges)})))

(rf/reg-sub
 m/preview-show-hide
 (fn [[_ ctx]]
   {:visible-nodes-edges-ids (rf/subscribe
                              [m/visible-nodes-edges-ids ctx])
    :main-map-profile-id (rf/subscribe [m/main-map-profile-id ctx])
    :map-profile-ids-set (rf/subscribe [m/map-profile-ids-set ctx])
    :connector-ids-set (rf/subscribe [m/connector-ids-set ctx])
    :connection-tuples-by-node-id (rf/subscribe
                                   [m/connection-tuples-by-node-id ctx])
    :ephemeral-hide-rules (rf/subscribe [m/ephemeral-hide-rules ctx])
    :display-visibility-changes? (rf/subscribe [m/display-visibility-changes? ctx])})
 (fn [args _]
   (resolve-preview-changes args)))

(defn visible-map-profiles
  [{:keys [map-profiles visible-node-ids-set]}]
  (let [;;preview-visible (:show-nodes preview-show-hide)
        ;;visible (set/union visible-node-ids-set preview-visible)
        visible visible-node-ids-set]
    (->> map-profiles
         (filterv (fn [{:keys [db/id]}]
                    (contains? visible id))))))

(rf/reg-sub
 m/visible-map-profiles
 (fn [[_sub-id ctx]]
   {:map-profiles (rf/subscribe [m/map-profiles ctx])
    :visible-node-ids-set (rf/subscribe [m/visible-node-ids-set ctx])
    :preview-show-hide (rf/subscribe [m/preview-show-hide ctx])})
 (fn [args [_ _ctx]]
   (visible-map-profiles args)))

(rf/reg-sub-raw
 m/connector-options
 (fn [_db-atom [_ {:keys [entity-types other-ids] :as _args}]]
   (ratom/reaction
    (let [session-entity-types @session/entity-types
          map-profiles (->> @(rf/subscribe [m/map-profiles])
                            (filterv (fn [mp]
                                       (contains? entity-types
                                                  (:graph-entity/entity-type mp))))
                            (filterv (fn [{:keys [db/id]}]
                                       (not (contains? other-ids id)))))
          mp-options (->> map-profiles
                          (mapv (fn [{:keys [graph-entity/label db/id]}]
                                  {:value id
                                   :label label})))
          mp-entity-ids (->> map-profiles
                             (into #{}
                                   (map :graph-entity/entity)))
          entity-options (->> entity-types
                              (mapcat (fn [et]
                                        (get session-entity-types et)))
                              (filterv (fn [{:keys [db/id]}]
                                         (not (contains? mp-entity-ids id))))
                              (filterv (fn [{:keys [db/id]}]
                                         (not (contains? other-ids id))))
                              (mapv (fn [{:keys [db/id] :as entity}]
                                      {:value id
                                       :label (entity/display-string entity)})))]
      (into mp-options entity-options)))))

(rf/reg-sub
 m/hiding-view?
 (fn [[_ ctx]]
   {:ephemeral (rf/subscribe [m/ephemeral ctx])})
 (fn [{:keys [ephemeral]} [_ {:keys [map-profile-id]}]]
   (get-in ephemeral [m/hiding-view-key map-profile-id :open?])))

(defn edit-map-profile-modal
  [{:keys [state]} _]
  (get state m/edit-map-profile-key))

(rf/reg-sub
 m/edit-map-profile-modal
 (fn [[_ ctx]]
   {:state (rf/subscribe [m/state ctx])})
 edit-map-profile-modal)

(rf/reg-sub
 m/edit-map-profile?
 (fn [[_ ctx]]
   {:edit-map-profile-modal (rf/subscribe [m/edit-map-profile-modal ctx])})
 (fn [{:keys [edit-map-profile-modal]} [_ {:keys [_map-profile-id]}]]
   (get edit-map-profile-modal :open?)))

(rf/reg-sub
 m/map-profile-edits
 (fn [[_ ctx]]
   {:edit-map-profile-modal (rf/subscribe [m/edit-map-profile-modal ctx])})
 (fn [{:keys [edit-map-profile-modal]} [_ {:keys [_map-profile-id]}]]
   (get edit-map-profile-modal :edits)))

(defn edit-connector-modal
  [{:keys [state]} _]
  (get state m/edit-connector-key))

(rf/reg-sub
 m/edit-connector-modal
 (fn [[_ ctx]]
   {:state (rf/subscribe [m/state ctx])})
 edit-connector-modal)

(rf/reg-sub
 m/edit-connector?
 (fn [[_ ctx]]
   {:edit-connector-modal (rf/subscribe [m/edit-connector-modal ctx])})
 (fn [{:keys [edit-connector-modal]} [_ {:keys [_connector-id]}]]
   (get edit-connector-modal :open?)))

(rf/reg-sub
 m/connector-edits
 (fn [[_ ctx]]
   {:edit-connector-modal (rf/subscribe [m/edit-connector-modal ctx])})
 (fn [{:keys [edit-connector-modal]} _]
   (get edit-connector-modal :edits)))

(defn resolve-hidden-preview-connector
  [{:keys [ephemeral-hide-rules]} [_ {:keys [connector-id]}]]
  (hidden-connector? ephemeral-hide-rules {:db/id connector-id}))

(rf/reg-sub
 m/hidden-preview-connector?
 (fn [[_ ctx]]
   {:ephemeral-hide-rules (rf/subscribe [m/ephemeral-hide-rules ctx])})
 resolve-hidden-preview-connector)

(defn settings
  [{:keys [ephemeral]} _]
  (get ephemeral m/settings-key))

(rf/reg-sub
 m/settings
 (fn [[_ ctx]]
   {:ephemeral (rf/subscribe [m/ephemeral ctx])})
 settings)

(defn settings?
  [{:keys [settings]} _]
  (get settings :open?))

(rf/reg-sub
 m/settings?
 (fn [[_ ctx]]
   {:settings (rf/subscribe [m/settings ctx])})
 settings?)

(defn delete-modal
  [{:keys [state]} _]
  (get state m/delete-modal-key))

(rf/reg-sub
 m/delete-modal
 (fn [[_ ctx]]
   {:state (rf/subscribe [m/state ctx])})
 delete-modal)

(defn create-connector-modal
  [{:keys [state]} _]
  (get state m/create-connector-modal-key))

(rf/reg-sub
 m/create-connector-modal
 (fn [[_ ctx]]
   {:state (rf/subscribe [m/state ctx])})
 create-connector-modal)

(defn validate-map-profile-section
  [{:keys [edits new-map-profile?]}]
  (let [{:keys [graph-entity/label]} edits
        blank-label? (if new-map-profile?
                       (string/blank? label)
                       ;; for existing map-profile check only if non-nil:
                       (and (some? label)
                            (string/blank? label)))
        validations (cond-> {}
                      blank-label? (assoc :graph-entity/label
                                          (loc/tr :map-name-must-not-be-blank)))]
    validations))

(defn validate-create-connector-modal
  [{:keys [create-connector-modal edit-map-profile-modal]} _]
  (let [{:keys [selected]} (:edits create-connector-modal)
        validations (cond-> {}
                      (nil? selected) (assoc :selected (loc/tr :must-select-one)))
        map-profile-validations (validate-map-profile-section edit-map-profile-modal)
        validations (merge validations map-profile-validations)]
    (when (seq validations)
      validations)))

(rf/reg-sub
 m/validate-create-connector-modal
 (fn [[_ ctx]]
   {:create-connector-modal (rf/subscribe [m/create-connector-modal ctx])
    :edit-map-profile-modal (rf/subscribe [m/edit-map-profile-modal ctx])})
 validate-create-connector-modal)

(defn map-profile-changes?
  [map-profile edits]
  (->> edits
       (some (fn [[k v]]
               (not= (get map-profile k)
                     v)))))

(defn validate-edit-graph-ref-modal
  [{:keys [entities edit-connector-modal edit-map-profile-modal]} _]
  (let [{:keys [edits connector-id other-mp-id]} edit-connector-modal
        gref (get entities connector-id)
        {:keys [graph-reference/type]} gref
        metadatas (get graph-reference/graph-references-metadata type)
        metadatas-blank (->> metadatas
                             (filterv (fn [attribute]
                                        (and (contains? edits attribute)
                                             (cu/blank-value?
                                              (get edits attribute)))))
                             (mapv (fn [attribute]
                                     {attribute (loc/tr :must-not-be-blank
                                                    [(loc/tr attribute)])}))
                             (into {}))
        gref-changes? (->> metadatas
                           (some (fn [attribute]
                                   (and (contains? edits attribute)
                                        (not= (get edits attribute)
                                              (utils/metadata-value gref attribute))))))
        mp (when other-mp-id
             (get entities other-mp-id))
        map-profile-validations (validate-map-profile-section edit-map-profile-modal)
        mp-changes? (when other-mp-id
                      (map-profile-changes? mp (:edits edit-map-profile-modal)))
        validations (cond-> metadatas-blank
                      (and (not gref-changes?)
                           (not mp-changes?)
                           (empty? map-profile-validations))
                      (assoc :changes (loc/tr :no-changes)))
        validations (merge validations map-profile-validations)]
    (when (seq validations)
      validations)))

(rf/reg-sub
 m/validate-edit-graph-ref-modal
 (fn [[_ ctx]]
   {:edit-connector-modal (rf/subscribe [m/edit-connector-modal ctx])
    :entities (rf/subscribe [::session-sub/entities])
    :edit-map-profile-modal (rf/subscribe [m/edit-map-profile-modal ctx])})
 validate-edit-graph-ref-modal)

(defn node-menu
  [{:keys [state]} _]
  (get state m/node-menu-key))

(rf/reg-sub
 m/node-menu
 (fn [[_ ctx]]
   {:state (rf/subscribe [m/state ctx])})
 node-menu)

(defn edge-menu
  [{:keys [state]} _]
  (get state m/edge-menu-key))

(rf/reg-sub
 m/edge-menu
 (fn [[_ ctx]]
   {:state (rf/subscribe [m/state ctx])})
 edge-menu)

(defn reconnecting
  [{:keys [ephemeral]} _]
  (get ephemeral m/reconnecting-key))

(rf/reg-sub
 m/reconnecting
 (fn [[_ ctx]]
   {:ephemeral (rf/subscribe [m/ephemeral ctx])})
 reconnecting)

(defn reconnecting-node-id
  [{:keys [reconnecting]} _]
  (get reconnecting :map-profile-id))

(rf/reg-sub
 m/reconnecting-node-id
 (fn [[_ ctx]]
   {:reconnecting (rf/subscribe [m/reconnecting ctx])})
 reconnecting-node-id)

(rf/reg-sub
 m/label-positions
 (fn [[_ ctx]]
   {:view-config (rf/subscribe [m/view-config ctx])})
 (fn [{:keys [view-config]} _]
   (get-in view-config [:connectors m/label-positions-key])))

(rf/reg-sub
 m/label-position
 (fn [[_ ctx]]
   ;;TODO view-global default & connector-type specific defaults
   {:label-positions (rf/subscribe [m/label-positions ctx])})
 (fn [{:keys [label-positions]} [_ {:keys [connector-id] :as _ctx}]]
   (get label-positions connector-id :center)))

(rf/reg-sub
 m/selecting?
 (fn [[_ ctx]]
   {:state (rf/subscribe [m/state ctx])})
 (fn [{:keys [state]} _]
   (get state m/selecting-key)))
